import { MultipleSelect } from "../components/Inputs/MultipleSelect";
import { Type, Validator } from "./Type";
import { ListPresentationComponent } from "./ListInputField";

export interface MultipleSelectOptions
  extends Array<{
    label: string;
    value: string | number | string[] | undefined;
  }> {}

export const MultipleSelectField = (
  options: MultipleSelectOptions,
  ...validators: Validator[]
) =>
  new Type({
    // @ts-ignore
    Component: MultipleSelect,
    PresentationComponent: ListPresentationComponent,
    props: {
      options
    },
    validators
  });
